<template>
  <div class="d-flex flex-column flex-root">
    <div
      class="login login-1 d-flex flex-column flex-lg-row flex-column-fluid bg-white login-signin-on"
      id="kt_login">
      <!--begin::Aside-->
      <div
        class="login-aside d-flex flex-column flex-row-auto bg-light no-overflow">
        <div class="d-flex flex-column-auto flex-column pt-lg-30 pt-15">
          <a
            href="#"
            class="text-center mb-10">
            <img
              src="media/logos/logo.svg"
              class="max-h-50px no-select"
              alt=""/>
          </a>
        </div>
        <div
          class="aside-img d-flex flex-row-fluid bgi-no-repeat bgi-position-y-bottom bgi-position-x-center"
          style="margin-bottom: -100px"
          :style="{ backgroundImage: `url(${backgroundImage})` }"></div>
      </div>
      <!--begin::Aside-->
      <!--begin::Content-->
      <div
        class="login-content flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden p-7 mx-auto">
        <div class="d-flex flex-column-fluid flex-center">
          <!--begin::Signin-->
          <div class="login-form login-signin">
            <form
              class="form"
              novalidate="novalidate"
              id="kt_login_signin_form">
              <div class="pb-10 pt-lg-0 pt-5">
                <h3
                  class="font-weight-bolder text-dark font-size-h4 font-size-h1-lg mb-5">
                  Login to your account
                </h3>
                <span class="text-muted">
                  Welcome to the <span class="font-weight-bold">Hexallion VPN Admin Panel</span>!<br />
                  Please type your username and password to proceed.
                </span>
              </div>
              <div class="form-group">
                <label class="font-weight-bolder text-dark">Username</label>
                <div
                  id="example-input-group-1"
                  label=""
                  label-for="example-input-1">
                  <input
                    class="form-control form-control-lg form-control-solid h-auto rounded-md"
                    type="text"
                    name="username"
                    ref="username"
                    v-model="form.username"/>
                </div>
              </div>
              <div class="form-group">
                <div class="d-flex justify-content-between mt-n5">
                  <label class="font-weight-bolder text-dark pt-5">Password</label>
                </div>
                <div
                  id="example-input-group-2"
                  label=""
                  label-for="example-input-2">
                  <input
                    class="form-control form-control-lg form-control-solid h-auto rounded-md"
                    type="password"
                    name="password"
                    ref="password"
                    v-model="form.password"
                    autocomplete="off"/>
                </div>
              </div>
              <div class="pb-lg-0 pb-5">
                <b-button
                  type="submit"
                  v-wave
                  size="lg"
                  variant="primary"
                  class="btn btn-primary font-weight-bolder d-inline-flex align-items-center btn-shadow"
                  :disabled="responses.auth || responses.authToken">
                  <span>Sign In</span>
                  <b-spinner
                    v-if="responses.auth"
                    small
                    type="grow"
                    class="ml-3"></b-spinner>
                </b-button>
              </div>
            </form>
          </div>
          <!--end::Signin-->
        </div>
      </div>
      <!--end::Content-->
    </div>
  </div>
</template>

<!-- Load login custom page styles -->
<style lang="scss">
@import "@/assets/sass/pages/login/login-1.scss";
</style>

<script>
import formValidation from '@/assets/plugins/formvalidation/dist/es6/core/Core'

// FormValidation plugins
import Trigger from '@/assets/plugins/formvalidation/dist/es6/plugins/Trigger'
import Bootstrap from '@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap'
import SubmitButton from '@/assets/plugins/formvalidation/dist/es6/plugins/SubmitButton'

import KTUtil from '@/assets/js/components/util'
import { mapGetters, mapState } from 'vuex'
import {
  LOGIN,
  LOGOUT,
  AUTH_TOKEN
} from '@/core/services/store/auth.module'

export default {
  name: 'Login',
  data() {
    return {
      state: 'signin',
      form: {
        username: '',
        password: '',
      },
    }
  },
  computed: {
    ...mapState({
      errors: (state) => state.auth.errors,
      responses: (state) => state.auth.responses,
    }),
    ...mapGetters(['currentUser']),

    backgroundImage() {
      return process.env.BASE_URL + 'media/misc/login-aside.png'
    },

    urlToken() {
      return this.$route.query.token
    },
  },
  watch: {
    /* eslint-disable-next-line no-unused-vars */
    urlToken(newVal, oldVal) {
      if (newVal) {
        this.authToken(newVal)
      }
    }
  },
  mounted() {
    const signin_form = KTUtil.getById('kt_login_signin_form')

    this.fv = formValidation(signin_form, {
      fields: {
        username: {
          validators: {
            notEmpty: {
              message: 'Username is required',
            },
          },
        },
        password: {
          validators: {
            notEmpty: {
              message: 'Password is required',
            },
          },
        },
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap(),
      },
    })

    this.fv.on('core.form.valid', () => {
      var username = this.form.username
      var password = this.form.password

      // clear existing errors
      this.$store.dispatch(LOGOUT)

      // send login request
      this.$store
        .dispatch(LOGIN, { username, password })
        // go to which page after successfully login
        .then(() => this.$router.push({ name: 'ServersList' }))
        .catch(() => {})
    })

    if (this.urlToken) {
      this.authToken(this.urlToken)
    }
  },
  methods: {
    authToken(token) {
      this.$store
        .dispatch(AUTH_TOKEN, token)
        .then(() => this.$router.push({ name: 'ServersList' }))
        .catch(() => {})
    }
  },
}
</script>
